import React, { useEffect, useState } from "react";
import SingleSlider from "../../containers/HomeFive/SingleSlider";
import SocialList from "../../containers/HomeTwo/SocialList";
import { getSocialfeed } from "../../Services/service";

function FeatureSection() {
const [featureinfo , setFeatureinfo]=useState()
useEffect(() => {
  loadData();
},[]);
async function loadData() {
  const fd=await getSocialfeed();
  setFeatureinfo(fd);
}
console.log(featureinfo)
  return (
    <section className="binduz-er-featured-area">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-6">
            <SingleSlider title="Technology" />
          </div>
          <div className="col-lg-4 col-md-6">
            <SingleSlider title="Lifestyle" />
          </div>
            {featureinfo && featureinfo.featuresectioninfo.map((item)=>{
              return(
                <div className="col-lg-4">
            <div className="binduz-er-sidebar-social">
              <div className="binduz-er-sidebar-title">
                <h4 className="binduz-er-title">{item.title}</h4>
              </div>
              <div className="binduz-er-social-list">
                <SocialList />
              </div>
              <div className="binduz-er-sidebar-add mt-20">
                <h3 className="binduz-er-title">
                  {item.i1}<span>{item.i2}</span>
                </h3>
                <a className="binduz-er-main-btn" href="#">
                  {item.purchase}
                </a>
              </div>
            </div>
          </div>
            )})}
        </div>
      </div>
    </section>
  );
}

export default FeatureSection;
